<div class="qb-w-100 qb-h-100 qb-d-flex qb-fd-coloumn">
  <div class="qb-header-container">
    <div class="head-title">Push Notification Review</div>
    <mat-icon
      class="qb-close-container"
      (click)="cancel()"
      data-button-name="Close"
      >cancel</mat-icon
    >
  </div>
  <div class="qb-h-100 qb-display-cobtainer" style="overflow: auto">
    <div>
      <div class="main-label-style">Template Name</div>
      <div>
        {{ data.templateName }}
      </div>
    </div>
    <div>
      <div
        class="tabs-challenge"
        *ngIf="data?.aliasCountryCode && data?.aliasCountryCode?.length > 0"
      >
        <div class="qb-tab-container">
          <div
            class="tab-label"
            *ngFor="let type of languageTypeList"
            (click)="setLanguageType(type)"
            [ngClass]="{
              'active-category-challenge': selectedLanguageType === type.value
            }"
          >
            {{ type.displayName }}
          </div>
        </div>
      </div>
      <app-push-notification-view
        [header]="checkWhetherAlias() ? data?.aliasHeader : data?.header"
        [body]="checkWhetherAlias() ? data?.aliasBody : data?.body"
        [uploadedImg]="data?.uploadedImg"
      ></app-push-notification-view>
    </div>
  </div>
</div>
